const config = {
  firebase: {
    config: {
      apiKey: 'AIzaSyDqrxz_LuE44Q6w75Co43d-bDGPqOmxFOI',
      authDomain: 'emetworks-fds-34206.firebaseapp.com',
      databaseURL: 'https://emetworks-fds-34206.firebaseio.com',
      projectId: 'emetworks-fds-34206',
      storageBucket: 'emetworks-fds-34206.appspot.com',
      messagingSenderId: '106010554649',
      appId: '1:106010554649:web:877c94877150172a',
      measurementId: 'G-E9L2DFXXGR',
    },
    messaging: {
      publicKey: 'BKPJwkh-A12Q4mv5KxB_XhaR_RHfYMpTWIH7J4h-UnDxBjcxmpPtjPKqDxjC-ofpsVs8j3yAE4RnKBrQusN21xM',
    },
    status: false,
  },
  api: {
    url: 'http://192.168.1.100:3002',
    // url: 'https://apiv2.airpresense.tech'
  },
  vconsole: {
    enabled: true,
  },
  groupNotification: true,
  cache: true,
  style: {
    useHN: false,
  },
  configType: true,
  battery: {
    hideBatteryAfter: 1440,
  },
  features: {
    report: {
      vitalSign: false,
    },
    auth: {
      authMode: 'cognito', //cognito,local
    },
  },
};
module.exports = config;
